export enum ExperimentArm {
  Honduras = "Honduras",
  AiTutor = "AI Tutor",
  GreatOaks = "Great Oaks",
  HumanOnly = "Human Only",
}
